
import { defineComponent, ref, watch } from 'vue'
import {useRoute} from 'vue-router'
import store from '@/store'

export default defineComponent({
    setup() {
		const local = ref(store.subreddit.state);
		const route = useRoute()
		function init(name?: string) {
			document.title = `r/${name ?? route.params.name} | (not) reddit`;
			store.subreddit.actions.bindPosts(
				name || route.params.name.toString()
			);
			local.value.menu = 'home';
		}
		init();
		watch(
			() => route.params.name,
			(name) => {
				if (!name) return;
				store.subreddit.state.posts = [];
				init(name.toString());
				window.scrollTo(0, 0);
			}
		);

		return {
			store,
			local,
		};
    },
})
